import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { OrderStatus } from 'src/app-admin/_appCommon/base/AppInterfaceAndBaseClasses';
import { AppClientContext } from 'src/app-client/_appCommon/base/AppClientContext';
import { OrderPaymentStatus } from 'src/app-client/_appCommon/base/AppInterfaceAndBaseClasses';
import { ListControllerBase } from 'src/app-client/_appCommon/base/ListControllerBase';
import { UrlQueryDef } from 'src/app-client/_appCommon/base/UrlQueryDef';
import { Tools } from 'src/app-client/_appCommon/util/Tools';
import { CustomerDataService } from 'src/app-client/_dataservices/CustomerDataService';
import { OrderDataService } from 'src/app-client/_dataservices/OrderDataService';

@Component({
  selector: 'app-orders-list-home',
  templateUrl: './orders-list-home.component.html',
  styleUrls: ['./orders-list-home.component.css']
})
export class OrdersListHomeComponent extends ListControllerBase<OrderDataService> implements OnInit {

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('paginator') paginator!: MatPaginator;
  public dataSource: MatTableDataSource<any>;
  public rowsSize = 10;
  public rowsSizeOptions = [10, 25, 50, 100];
  public loading = true;

  public displayedColumns: any[] = [
    { property: 'code', display: 'Código', pipe: null },
    { property: 'patientName', display: 'Nombre del paciente', pipe: null },
    { property: 'patientEmail', display: 'Correo electrónico del paciente', pipe: null },
    { property: 'productName', display: 'Nombre del producto', pipe: null },
    { property: 'caseId', display: 'Hipervínculo al caso', pipe: null },
    { property: '', display: 'Acciones', pipe: null }
  ];

  public columnsToDisplay: any[] = this.displayedColumns.map(col => col.display);
  
  public currentCustomer: any; // Current customer logged-in

  constructor(title: Title, protected dataService: OrderDataService, private customerDataService: CustomerDataService, private router: Router) { 
    super("Orders", title, dataService);
  }

  ngOnInit(): void {
    this.getCustomerInfo();
    super.ngOnInit();
  }

  public override getAll(paged: boolean = false, matOrderActivated: boolean = false): void
  {
    if(this.currentCustomer){
      this.onBeforeGetAll();

      /*if (this.isPagingActive)
      {
        this.updatePaginationData();
        return;
      }*/
  
      this.dataService.getAssignedOrdersWithPendingPayment(this.getQueryDefForGetAll())
        .subscribe((response: any) =>
        {
          //Check if we have a paged result
          if (response.records != undefined && response.totalRecords != undefined)
          {
            this.dataRows = response.records;
            this.totalRows = response.totalRecords;
          }
          else
          {
            this.dataRows = response;
          }
  
          if (this.paginator && !paged)
            this.paginator.firstPage();
  
          this.dataRowsCopy = this.dataRows;
          this.onAfterGetAll();
        });
    }
  }

   protected override getQueryDefForGetAll(): UrlQueryDef
    {
      var queryDef = new UrlQueryDef();
  
      this.onGetQueryDefForGetAll(queryDef, );
  
      return queryDef;
  }

  protected onGetQueryDefForGetAll(queryDef: UrlQueryDef, matOrderActivated: boolean = false)
  {
    queryDef.params = {};
    queryDef.includes = 'PorCobrarOrder';

    if(this.paginator && !matOrderActivated){
      queryDef.params['pageNo'] = this.paginator.pageIndex + 1;
      queryDef.params['pageSize'] = this.paginator.pageSize;
    }

    queryDef.params["customerId"] = this.currentCustomer.id;
    queryDef.params["status"] = OrderStatus.Approved;
    queryDef.params["paymentStatus"] = OrderPaymentStatus.InProcess;

    super.onGetQueryDefForGetAll(queryDef);
  }

  protected override onAfterGetAll()
  {
    this.dataSource = new MatTableDataSource<any>(this.dataRows);
    this.dataSource.sortingDataAccessor = Tools.sortingDataAccessor;
    this.dataSource.sort = this.sort;
    this.loading = false;

    //super.onAfterGetAll();
  }

  private getCustomerInfo()
  {
    if (AppClientContext.Instance.user)
    {
      this.customerDataService.getByUserId(AppClientContext.Instance.user.id)
        .subscribe((customerResponse: any) =>
        {
          this.currentCustomer = customerResponse.items.firstOrNull();
          if (this.currentCustomer)
          {
            AppClientContext.Instance.customerId = this.currentCustomer.id;
            this.getAll();
          }
          else
          {
            this.setWarningAlert('Usuario no encontrado.')
          }
        });
    }
    else
    {
      this.setWarningAlert('Usuario no encontrado.')
    }
  }

  public goToCheckout(id): void
  {
    this.router.navigate(['/ecommerce/checkout-pending-payment'], {queryParams: {'orderId': id}});
  }
}
